import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import ataLogo from "../assets/img/logo_ata.png";
import shortLogo from "../assets/img/ataLogo.png";
import store from "../store/Store";
import { logout } from "../services/authService";



function Sidebar({ pinned, setPinned }) {
	const [userData, setUserData] = useState([]);
	const [pinnedBtnState, setPinnedBtnState] = useState(false);
	function clickHandler() {
		setPinned(!pinned);
		setPinnedBtnState(!pinnedBtnState);
	}
	const pinnedClassForPin = pinned ? "pinnedBtnActive" : "pinnedBtn";
	const pinnedClassForSidebar = pinned ? "pinnedNavbar active" : "navbar";
	const pinnedClassForSidebarChild = pinned
		? "sidebar__bookingChild"
		: "sidebar__bookingChild";

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	function MenuIcon(item) {
		if (item === "HOME") {
			return <i class="bx bxs-home-alt-2 sidebar__heading_icon"></i>;
		}
		if (item === "BOOKING") {
			return <i class="bx bxs-book-content sidebar__heading_icon"></i>;
		}
		if (item === "PICKUP") {
			return <i class="bx bxs-truck sidebar__heading_icon"></i>;
		}
		if (item === "EMAIL") {
			return <i class="bx bxs-envelope sidebar__heading_icon"></i>;
		}
		if (item === "DOCUMENTS") {
			return <i class="bx bxs-file-doc sidebar__heading_icon"></i>;
		}
		if (item === "ETA") {
			return <i class="bx bxs-time sidebar__heading_icon"></i>;
		}
		if (item === "Supplier") {
			return <i class="bx bxs-truck sidebar__heading_icon"></i>;
			
		}
		if (item === "Reports") {
			return <i class="bx bxs-file-doc sidebar__heading_icon"></i>;
			
		}
	}

	function subMenuLink(item) {
		if (item === "Dashboard") {
			return "/dashboard/overview";
		}
		if (item === "Tractor") {
			return "/dashboard/booking/tractor";
		}
		if (item === "Aggregate") {
			return "/dashboard/booking/aggregate";
		}
		if (item === "5M") {
			return "/dashboard/booking/fiveM";
		}
		if (item === "Transporter") {
			return "/dashboard/Transporter";
		}
		if (item === "Container Diversion") {
			return "/dashboard/Container-Diversion";
			
		}
		if (item === "Arrival Report") {
			return "/dashboard/arrival-report";
		}
		if (item === "Container Master") {
			return "/dashboard/container-master";
		}
		if (item === "Departure Report") {
			return "/dashboard/departure-report";
		}
		if (item === "VGM") {
			return "/dashboard/VGM";
		}
		if (item === "Share Email") {
			return "/dashboard/share-email";
		}
		if (item === "Container Report") {
			return "/dashboard/container-report";
		}
		if (item === "Tractor ETA"){
			return "/dashboard/tractor-ETA";

		}
		if (item === "Aggregate ETA"){
			return "/dashboard/aggregate-ETA";

		}
		if (item === "Supplier S2"){
			return "/dashboard/Supplier-s2";

		}
		if (item === "Uploaded File List"){
			return "/dashboard/UploadedFiles";

		}
		if (item === "Reports"){
			return "/dashboard/Reports";

		}
		if (item === "Factory"){
			return "/dashboard/Factory";

		}
	
		if (item === "Supplier"){
			return "/dashboard/Supplier";

		}
		if (item === "Shared"){
			return "/dashboard/Shared";

		}
		if (item === "Management"){
			return "/dashboard/Management";

		}
			if (item === "7Y Reports"){
			return "/dashboard/hound";

		}
		return "not-allowed";
	}

	function subMenuIcon(item) {
		if (item === "Dashboard") {
			return <i class="bx bxs-dashboard icons-custom"></i>;
		}
		if (item === "Tractor") {
			return <i className="fi fi-rr-school-bus icons-custom "></i>;
		}
		if (item === "Aggregate") {
			return <i className="fi fi-rr-chart-network icons-custom "></i>;
		}
		if (item === "5M") {
			return <i className="fi fi-rr-credit-card icons-custom "></i>;
		}
		if (item === "Transporter") {
			return <i className="fi fi-rr-road icons-custom"></i>;
		}
		if (item === "Container Diversion") {
			return <i className="fi fi-rr-road icons-custom"></i>;
		}
		if (item === "Arrival Report") {
			return (
				<i
					class="bx bx-log-out-circle icons-custom"
					style={{ transform: "scale(1.3)" }}
				></i>
			);
		}
		if (item === "Container Master") {
			return <i className="bx bxs-book-content icons-custom"></i>;
		}
		if (item === "Departure Report") {
			return (
				<i
					class="bx bx-log-in-circle icons-custom"
					style={{ transform: "scale(1.3)" }}
				></i>
			);
		}
		if (item === "VGM") {
			return <i className="bx bxs-collection icons-custom"></i>;
		}
		if (item === "Share Email") {
			return <i class="bx bxs-send icons-custom"></i>;
		}
		if (item === "Invoice Packing Email") {
			return <i class="bx bxs-send icons-custom"></i>;
		}
		if (item === "VGM Email") {
			return <i class="bx bxs-send icons-custom"></i>;
		}
		if (item === "Container Report") {
			return <i className="bx bxs-report icons-custom"></i>;
		}
		if (item === "Tractor ETA") {
			return <i className="fi fi-rr-school-bus icons-custom "></i>;
		}
		if (item === "Aggregate ETA") {
			return <i className="fi fi-rr-chart-network icons-custom "></i>;
		}
		if (item === "Supplier S2") {
			return <i className="fi fi-rr-school-bus icons-custom "></i>;
		}
		if (item === "Uploaded File List") {
			return <i className="bx bxs-report icons-custom "></i>;
		}
		
			if (item === "Factory") {
			return <i className="bx bxs-report icons-custom"></i>
			
		}
			if (item === "Supplier") {
			return <i className="bx bxs-report icons-custom"></i>
			
		}
			if (item === "Shared") {
			return <i className="bx bxs-report icons-custom"></i>
			
		}
			if (item === "Management") {
			return <i className="bx bxs-report icons-custom"></i>
			
		}
			if (item === "7Y Reports") {
			return <i className="bx bxs-report icons-custom"></i>
			
		}
		
	}

	function menuCSS(sidebarMenu) {
		if (sidebarMenu === "HOME") {
			if (window.location.pathname === "/dashboard/overview") {
				return "activeSidebarSubmenu__HOME";
			} else {
				return "sidebar__heading_submenu";
			}
		}
		if (sidebarMenu === "BOOKING") {
			if (
				window.location.pathname === "/dashboard/booking/tractor" ||
				window.location.pathname === "/dashboard/booking/aggregate" ||
				window.location.pathname === "/dashboard/booking/fiveM"
			) {
				return "activeSidebarSubmenu__BOOKING";
			} else {
				return "sidebar__heading_submenu";
			}
		}
		if (sidebarMenu === "PICKUP") {
			if (
				window.location.pathname === "/dashboard/Transporter" ||
				window.location.pathname === "/dashboard/arrival-report" ||
				window.location.pathname === "/dashboard/container-master" ||
				window.location.pathname === "/dashboard/departure-report" ||
				window.location.pathname === "/dashboard/VGM"
			) {
				return "activeSidebarSubmenu__PICKUP";
			} else {
				return "sidebar__heading_submenu";
			}
		}
		if (sidebarMenu === "EMAIL") {
			if (window.location.pathname === "/dashboard/share-email") {
				return "activeSidebarSubmenu__EMAIL";
			} else {
				return "sidebar__heading_submenu";
			}
		}
		if (sidebarMenu === "DOCUMENTS") {
			if (window.location.pathname === "/dashboard/container-report") {
				return "activeSidebarSubmenu__DOCUMENT";
			} else {
				return "sidebar__heading_submenu";
			}
		}
		
		if (sidebarMenu === "Reports") {
				if (window.location.pathname === "/dashboard/Supplier-s2") {
					return "activeSidebarSubmenu__DOCUMENT";
				} else {
					return "sidebar__heading_submenu";
				}
				if (window.location.pathname === "/dashboard/UploadedFiles") {
					return "activeSidebarSubmenu__DOCUMENT";
				} else {
					return "sidebar__heading_submenu";
				}
		} else {
			return "sidebar__heading_submenu";
		}
        
			if (sidebarMenu === "DOCUMENTS") {
			if (window.location.pathname === "/dashboard/container-report") {
				return "activeSidebarSubmenu__DOCUMENT";
			} else {
				return "sidebar__heading_submenu";
			}
		}
	
		
	
		

		
		
	}
	var sameIdDataMap = {};
	for (const item of userData) {
		if (item.View === 1) {
			if (sameIdDataMap.hasOwnProperty(item.ModuleName)) {
				sameIdDataMap[item.ModuleName].push({
					...item,
				});
			} else {
				sameIdDataMap[item.ModuleName] = [
					{
						...item,
					},
				];
			}
		}
	}
	function sidebarClickHandler() {
		setPinned(true);
		setPinnedBtnState(true);
	}
	return (
		<>
			<nav className={`${pinnedClassForSidebar}`} onClick={sidebarClickHandler}>
				<Link to="/dashboard/overview">
					<div className="icon-container">
						<img
							src={ataLogo}
							alt="ATA Freight"
							className="ataLogo"
							style={{ height: "48px", marginTop: "10px",marginBottom: "10px" }}
						/>
						<img
							src={shortLogo}
							alt="ATA Freight Logo"
							className="ataShortLogo"
							style={{ marginTop: "10px" }}
						/>
					</div>
				</Link>

				<ul className="navbar-nav">
					<div className="menu-wrapper">
						{Object.keys(sameIdDataMap).map((sidebarMenu) => {
							return (
								<>
									<div className={menuCSS(sidebarMenu)} key={sidebarMenu}>
										{sidebarMenu !== "HOME" && (
											<span className="sidebar__heading">
												{MenuIcon(sidebarMenu)}
												<span className="area-divider">{sidebarMenu}</span>
											</span>
										)}
										<div className="sidebar__submenu_collection">
											{sameIdDataMap[sidebarMenu].map((item) => {
												return (
													item.MenuName !== "Daily Plan Email" &&
													item.MenuName !== "Invoice Packing Email" &&
													item.MenuName !== "VGM Email" &&
													item.MenuName !== "Dashboard" && (
														<div className={pinnedClassForSidebarChild}>
															<li>
																<NavLink to={subMenuLink(item.MenuName)}>
																	{subMenuIcon(item.MenuName)}
																	<span className="sidebar__submenu_text">
																		{item.MenuName}
																	</span>
																</NavLink>
															</li>
														</div>
													)
												);
											})}
										</div>
									</div>
								</>
							);
						})}
					</div>

					<div className="sidebar__heading_submenu" onClick={logout}>
						<div className="sidebar__submenu_collection logout">
							<span className="sidebar__heading">
								<i className="bx bx-log-in sidebar__heading_icon"></i>
								<span className="area-divider">LogOut</span>
							</span>
						</div>
					</div>
				</ul>
			</nav>

			<button className={pinnedClassForPin} onClick={clickHandler}>
				<i className={`bx bx-chevron-${pinnedBtnState ? "left" : "right"}`}></i>
			</button>
		</>
	);
}

export default Sidebar;
